<div class="filter-bar">
  <input class="filter-input" [ngModel]="crewSearch" (ngModelChange)="setCrewSearch($event)" placeholder="Search crew…" autocomplete="off">
  <select class="filter-select" [ngModel]="crewAbilityFilter" (ngModelChange)="setCrewAbilityFilter($event)">
    <option *ngFor="let opt of crewAbilityOptions" [value]="opt.value">{{ opt.label }}</option>
  </select>
  <select class="filter-select" [ngModel]="crewCollectionFilter" (ngModelChange)="setCrewCollectionFilter($event)">
    <option *ngFor="let opt of crewCollectionOptions" [value]="opt.value">{{ opt.label }}</option>
  </select>
  <select class="filter-select" [ngModel]="crewRarityFilter" (ngModelChange)="setCrewRarityFilter($event)">
    <option *ngFor="let opt of crewRarityOptions" [value]="opt.value">{{ opt.label }}</option>
  </select>
</div>
<div class="crew-sort-bar">
  <span class="sort-col" (click)="setCrewSort('donationDate')">Last Donated<span class="sort-ind">{{ crewSortBy === 'donationDate' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
  <span class="sort-col" (click)="setCrewSort('rarity')">Rarity<span class="sort-ind">{{ crewSortBy === 'rarity' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
  <span class="sort-col" (click)="setCrewSort('name')">Name<span class="sort-ind">{{ crewSortBy === 'name' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
  <span class="sort-col" (click)="setCrewSort('level')">Level<span class="sort-ind">{{ crewSortBy === 'level' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></span>
</div>
<div class="crew-export-bar">
  <button class="btn-export" *ngIf="!exportMode && !exportSuccess" (click)="toggleExportMode(true)">Export crew</button>

  <ng-container *ngIf="exportMode">
    <button class="btn-export" [disabled]="selectedCrewIds.size === 0" (click)="exportSelectedCrew()">Export</button>
    <button class="btn-cancel" (click)="toggleExportMode(false)">Cancel</button>
    <span class="export-count">{{ selectedCrewIds.size }} selected</span>
  </ng-container>

  <button class="btn-exported" *ngIf="exportSuccess" disabled>Copied to clipboard</button>
</div>

<!-- Donated -->
<ng-container *ngIf="donatedCrew.length > 0">
  <div class="section-toggle section-toggle-sub" (click)="showDonated = !showDonated">
    <span>Donated <span class="toggle-count">({{ donatedCrew.length }})</span></span>
    <span class="toggle-arrow">{{ showDonated ? '▲' : '▼' }}</span>
  </div>
  <div class="crew-table-wrap" *ngIf="showDonated">
    <table class="crew-table">
      <thead>
        <tr>
          <th *ngIf="exportMode" class="ct-col-checkbox" (click)="$event.stopPropagation()">
            <input #donatedToggle type="checkbox"
                   [checked]="isSectionAllSelected(donatedCrew)"
                   [indeterminate]="isSectionAnySelected(donatedCrew) && !isSectionAllSelected(donatedCrew)"
                   (change)="setSectionSelection(donatedCrew, donatedToggle.checked)">
          </th>
          <th class="ct-col-sprite"></th>
          <th class="ct-col-rarity">Rarity</th>
          <th class="ct-col-name">Name</th>
          <th class="ct-col-collection">Collection</th>
          <th class="ct-col-level">Level</th>
          <th class="ct-col-status">Status</th>
          <th class="ct-col-borrowed-by">Borrowed By</th>
          <th class="ct-col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of donatedCrew" (click)="rowClicked(c)" class="crew-table-row">
          <td *ngIf="exportMode" class="ct-col-checkbox" (click)="$event.stopPropagation()">
            <input #cb type="checkbox" [checked]="isCrewSelected(c)" (change)="setCrewSelection(c, cb.checked)">
          </td>
          <td class="ct-col-sprite">
            <pss-sprite *ngIf="crewSpriteId(c.designId)" class="crew-sprite" [spriteId]="crewSpriteId(c.designId)"></pss-sprite>
          </td>
          <td class="ct-col-rarity">
            <span class="crew-rarity rarity-{{ crewRarity(c.designId) | lowercase }}">{{ crewRarity(c.designId) || '…' }}</span>
          </td>
          <td class="ct-col-name">{{ crewName(c) }}</td>
          <td class="ct-col-collection">{{ crewCollection(c) }}</td>
          <td class="ct-col-level">Lv {{ c.level }}</td>
          <td class="ct-col-status">
            <span class="crew-status crew-donated">{{ donationTimeLeft(c) || 'Donated' }}</span>
          </td>
          <td class="ct-col-borrowed-by" [title]="lastBorrowedAtLabel(c)">
            <span *ngIf="lastBorrowedBy(c); else noBorrower">{{ lastBorrowedBy(c) }}</span>
            <ng-template #noBorrower><span class="crew-muted">—</span></ng-template>
          </td>
          <td class="ct-col-actions" (click)="$event.stopPropagation()">
            <span class="crew-extend-hint" *ngIf="!canExtend(c)">{{ extendCooldownLeft(c) }}</span>
            <button class="btn-crew-action btn-extend" *ngIf="basicPlus"
                    [disabled]="crewBusy.get(c.characterId) || !canExtend(c)"
                    [title]="extendCooldownLeft(c)"
                    (click)="extend(c)">
              {{ crewBusy.get(c.characterId) ? '…' : 'Extend' }}
            </button>
            <span class="crew-err" *ngIf="crewError.get(c.characterId)">{{ crewError.get(c.characterId) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- Available to donate -->
<ng-container *ngIf="liftCrew.length > 0">
  <div class="section-toggle section-toggle-sub" (click)="showLift = !showLift">
    <span>Available to Donate <span class="toggle-count">({{ liftCrew.length }})</span></span>
    <span class="toggle-arrow">{{ showLift ? '▲' : '▼' }}</span>
  </div>
  <div class="crew-table-wrap" *ngIf="showLift">
    <table class="crew-table">
      <thead>
        <tr>
          <th *ngIf="exportMode" class="ct-col-checkbox" (click)="$event.stopPropagation()">
            <input #liftToggle type="checkbox"
                   [checked]="isSectionAllSelected(liftCrew)"
                   [indeterminate]="isSectionAnySelected(liftCrew) && !isSectionAllSelected(liftCrew)"
                   (change)="setSectionSelection(liftCrew, liftToggle.checked)">
          </th>
          <th class="ct-col-sprite"></th>
          <th class="ct-col-rarity sort-col" (click)="setCrewSort('rarity')">Rarity<span class="sort-ind">{{ crewSortBy === 'rarity' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></th>
          <th class="ct-col-name sort-col" (click)="setCrewSort('name')">Name<span class="sort-ind">{{ crewSortBy === 'name' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></th>
          <th class="ct-col-collection">Collection</th>
          <th class="ct-col-level sort-col" (click)="setCrewSort('level')">Level<span class="sort-ind">{{ crewSortBy === 'level' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></th>
          <th class="ct-col-donation-date sort-col" (click)="setCrewSort('donationDate')">Last Donated<span class="sort-ind">{{ crewSortBy === 'donationDate' ? (crewSortAsc ? ' ↑' : ' ↓') : '' }}</span></th>
          <th class="ct-col-actions"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of liftCrew" (click)="rowClicked(c)" class="crew-table-row">
          <td *ngIf="exportMode" class="ct-col-checkbox" (click)="$event.stopPropagation()">
            <input #cb type="checkbox" [checked]="isCrewSelected(c)" (change)="setCrewSelection(c, cb.checked)">
          </td>
          <td class="ct-col-sprite">
            <pss-sprite *ngIf="crewSpriteId(c.designId)" class="crew-sprite" [spriteId]="crewSpriteId(c.designId)"></pss-sprite>
          </td>
          <td class="ct-col-rarity">
            <span class="crew-rarity rarity-{{ crewRarity(c.designId) | lowercase }}">{{ crewRarity(c.designId) || '…' }}</span>
          </td>
          <td class="ct-col-name">{{ crewName(c) }}</td>
          <td class="ct-col-collection">{{ crewCollection(c) }}</td>
          <td class="ct-col-level">Lv {{ c.level }}</td>
          <td class="ct-col-donation-date">{{ lastDonationLabel(c) }}</td>
          <td class="ct-col-actions" (click)="$event.stopPropagation()">
            <button class="btn-crew-action" *ngIf="basicPlus"
                    [disabled]="crewBusy.get(c.characterId) || donatedCrew.length >= donationLimit"
                    [title]="donatedCrew.length >= donationLimit ? 'Donation limit reached (' + donationLimit + ')' : ''"
                    (click)="donate(c)">
              {{ crewBusy.get(c.characterId) ? '…' : 'Donate' }}
            </button>
            <span class="crew-err" *ngIf="crewError.get(c.characterId)">{{ crewError.get(c.characterId) }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>

<!-- Deployed -->
<div class="section-toggle section-toggle-sub" (click)="showDeployed = !showDeployed">
  <span>Deployed <span class="toggle-count">({{ deployedCrew.length }})</span></span>
  <span class="toggle-arrow">{{ showDeployed ? '▲' : '▼' }}</span>
</div>
<div class="crew-table-wrap" *ngIf="showDeployed">
  <table class="crew-table">
    <thead>
      <tr>
        <th *ngIf="exportMode" class="ct-col-checkbox" (click)="$event.stopPropagation()">
          <input #deployedToggle type="checkbox"
                 [checked]="isSectionAllSelected(deployedCrew)"
                 [indeterminate]="isSectionAnySelected(deployedCrew) && !isSectionAllSelected(deployedCrew)"
                 (change)="setSectionSelection(deployedCrew, deployedToggle.checked)">
        </th>
        <th class="ct-col-sprite"></th>
        <th class="ct-col-rarity">Rarity</th>
        <th class="ct-col-name">Name</th>
        <th class="ct-col-collection">Collection</th>
        <th class="ct-col-level">Level</th>
        <th class="ct-col-status">Room</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let c of deployedCrew" (click)="rowClicked(c)" class="crew-table-row">
        <td *ngIf="exportMode" class="ct-col-checkbox" (click)="$event.stopPropagation()">
          <input #cb type="checkbox" [checked]="isCrewSelected(c)" (change)="setCrewSelection(c, cb.checked)">
        </td>
        <td class="ct-col-sprite">
          <pss-sprite *ngIf="crewSpriteId(c.designId)" class="crew-sprite" [spriteId]="crewSpriteId(c.designId)"></pss-sprite>
        </td>
        <td class="ct-col-rarity">
          <span class="crew-rarity rarity-{{ crewRarity(c.designId) | lowercase }}">{{ crewRarity(c.designId) || '…' }}</span>
        </td>
        <td class="ct-col-name">{{ crewName(c) }}</td>
        <td class="ct-col-collection">{{ crewCollection(c) }}</td>
        <td class="ct-col-level">Lv {{ c.level }}</td>
        <td class="ct-col-status">
          <span class="crew-status crew-room">{{ roomName(c.roomDesignId) || 'Deployed' }}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
